import React from 'react'
import ReactDatePicker from 'react-date-picker'
import { Event, Clear } from '@material-ui/icons'

import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  datePicker: {
    boxSizing: 'border-box',
    fontFamily: `'Roboto', 'Helvetica', 'Arial', sans-serif`,
    fontSize: '16px',
    lineHeight: '19px',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.87)',
    width: '100%',
    '& .react-date-picker__wrapper': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '4px',
      padding: '12px 14px',
      width: '100%',
      color: 'black'
    }
  }
}))

const DatePicker: React.FC<{
  label?: string
  value: Date | null
  pickerHandler: (date: Date | null) => void
  required?: boolean
  maxDate?: Date | null
  minDate?: Date | null
}> = ({ label, value, pickerHandler, required = false, maxDate, minDate }) => {
  const classes = useStyles({})

  return (
    <ReactDatePicker
      calendarIcon={<Event />}
      clearIcon={<Clear />}
      className={classes.datePicker}
      onChange={(date: Date | null) => {
        pickerHandler(date)
      }}
      value={value}
      required={required}
      format={'yyyy年MM月dd日'}
      maxDate={maxDate}
      minDate={minDate}
    />
  )
}

export default DatePicker
